export const settingsCharm_ariaLabel = "oRv_dd";
export default {settingsCharm_ariaLabel};